import * as React from "react";
import Card from "@mui/material/Card";
import OutlinedInput from "@mui/material/OutlinedInput";
import CardHeader from "@mui/material/CardHeader";
import Divider from "@mui/material/Divider";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Unstable_Grid2";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import {useState} from "react";
import {Autocomplete, TextField} from "@mui/material";
import Chip from "@mui/material/Chip";
import User from "benchmarking-domain/user";

interface UserFormProps {
  user: User;
  onSubmit: (data: User) => Promise<void>;
}

export function UserForm({user, onSubmit}: UserFormProps): React.JSX.Element {
  const [prevUser, setPrevUser] = useState<User | undefined>(user);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const [name, setName] = useState<string>(user?.name ?? "");

  if(prevUser !== user) {
    setPrevUser(user);
    setName(user?.name ?? "");
  }

  const saveData = async ():Promise<void> => {
    setIsSaving(true);

    try {
      await onSubmit({ ...user, id: user?.id ?? "", name });
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <form
      onSubmit={async (event) => {
        event.preventDefault();
        await saveData();
      }}
    >
      <Card>
        <CardHeader subheader="The information can be edited" title={user ? "User" : "New user"}/>
        <Divider/>
        <CardContent>
          <Grid container spacing={3}>
            <Grid md={6} xs={12}>
              <FormControl fullWidth required>
                <InputLabel>Name</InputLabel>
                <OutlinedInput onChange={(e) => {
                  setName(e.target.value);
                }} value={name} label="Name" name="name"/>
              </FormControl>
            </Grid>
            <Grid md={6} xs={12}>
              <FormControl fullWidth required>
                <InputLabel>Email</InputLabel>
                <OutlinedInput value={user.email} label="Email" name="email" disabled/>
              </FormControl>
            </Grid>
            <Grid md={6} xs={12}>
              <FormControl fullWidth required>
                <Autocomplete
                  multiple
                  id="organisations-filled"
                  options={[]}
                  freeSolo
                  autoSelect
                  disabled
                  value={user.organisations ?? []}
                  renderTags={(value: string[], getTagProps) =>
                    value.map((option: string, index: number) => (
                      <Chip
                        variant="outlined"
                        label={option}
                        {...getTagProps({index})}
                        key={option}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Organisations"
                    />
                  )}
                />
              </FormControl>
            </Grid>
          </Grid>
        </CardContent>
        <Divider/>
        <CardActions sx={{justifyContent: 'flex-end'}}>
          <Button type="submit" variant="contained" disabled={isSaving}>{user ? "Save details" : "Create new user"}</Button>
        </CardActions>
      </Card>
    </form>
  );
}
